import { AlgoliaSearchManager } from "../utils/algolia-search-site";

export async function initSiteSearch() {
  const algoliaAppId = document.getElementById("algolia-site-app-id")?.value;
  const algoliaSearchKey = document.getElementById(
    "algolia-site-search-key",
  )?.value;
  const algoliaIndexName = document.getElementById(
    "algolia-site-index-name",
  )?.value;

  if (!algoliaAppId || !algoliaSearchKey || !algoliaIndexName) {
    console.error(
      "Algolia credentials missing. Cannot initialize site search.",
    );
    return;
  }

  const urlParams = new URLSearchParams(window.location.search);
  const initialQuery = urlParams.get("search") || "";

  const algoliaManager = new AlgoliaSearchManager(
    algoliaAppId,
    algoliaSearchKey,
    algoliaIndexName,
    "site-search-input",
    "algolia-site-results",
    "algolia-site-pagination",
    "algolia-site-results-count", // results count element
    "algolia-clear-search", // clear filter element
    document.getElementById("algolia-site-initial-filters")?.value,
    null, // initialSortByIndex
    initialQuery, // Pass initial query from URL
  );

  // Initial search is now handled within AlgoliaSearchManager constructor
  // algoliaManager.performSearch("");
  // algoliaManager.showSearchResults();
}
